export const TIME_CONDITION_EVENTS = [
  "message",
  "attachments",
  "status",
  "subject",
  "teamVisibility",
  "ticketCreation",
  "cc",
  "assignment",
  "requester",
  "rating",
  "ratingRequestSent",
  "followUpSent",
  "spam",
  "priority",
  "tags",
] as const;

export type TimeConditionEventType = (typeof TIME_CONDITION_EVENTS)[number];
